/**
 * The routes that render the live SessionRecorder. These are the ONLY routes
 * that render full-screen (no app header/sidebar) so the recorder's exit nudge
 * is the single way out - see ProtectedLayout. Kept in one place so App.tsx (the
 * route table) and ProtectedLayout (the chrome-less decision) can never drift:
 * a new session route added via these constants is full-screen by construction.
 */
export const SESSION_ROUTES = {
  staff: '/cases/:caseId/session/:encounterId',
} as const;

/** The session route for ONE encounter. One address for everyone: the recorder resolves what
 *  the actor may do from the server's capability flags, not from which path they arrived on. */
export function sessionPath(caseId: string, encounterId: string): string {
  return SESSION_ROUTES.staff.replace(':caseId', caseId).replace(':encounterId', encounterId);
}

/** All session route path patterns, for matchPath-based detection. */
export const SESSION_ROUTE_PATTERNS: readonly string[] = Object.values(SESSION_ROUTES);
